export * from "-!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/stylus-loader/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Comment.vue?vue&type=style&index=0&id=133ed8df&lang=stylus&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment.vue?vue&type=style&index=0&id=133ed8df&lang=stylus&
// module id = 616
// module chunks = 3